import { useState } from 'react';

const faqs = [
  {
    id: 1,
    q: '成全影视是免费的吗？需要注册会员吗？',
    a: '完全免费！成全影视坚持"免费观影"理念，无需注册、无需登录、无需任何付费会员。打开网站即可直接搜索和观看所有影视内容，没有任何隐藏收费或强制广告弹窗。',
  },
  {
    id: 2,
    q: '视频画质怎么样？支持哪些清晰度？',
    a: '平台主流内容支持1080P全高清画质，部分热门影片更提供4K超高清版本。我们采用先进的视频编码技术，在保证清晰度的同时优化带宽消耗，即使网速一般也能流畅观影。',
  },
  {
    id: 3,
    q: '可以在手机上观看吗？需要下载APP吗？',
    a: '成全影视全面适配手机、平板等移动设备，无需下载任何APP，通过手机浏览器即可直接访问观看。站点采用响应式设计+PWA技术，支持添加到手机主屏幕，像原生APP一样便捷。',
  },
  {
    id: 4,
    q: '影片更新速度快吗？新片多久能上线？',
    a: '我们的内容团队每日持续更新，热门电视剧通常播出后24小时内即可上线最新集数。电影方面，院线下映后通常1-3个月内会上线高清版本。每周新增影视资源超过100部。',
  },
  {
    id: 5,
    q: '播放卡顿怎么办？有办法解决吗？',
    a: '平台部署了全球CDN加速网络，通常情况下播放流畅不卡顿。如果遇到缓冲问题，可以尝试切换清晰度或刷新页面。我们也建议使用Chrome、Safari等主流浏览器获得最佳体验。',
  },
  {
    id: 6,
    q: '网站安全吗？会不会有病毒或恶意软件？',
    a: '成全影视高度重视用户安全，站点采用HTTPS加密传输，不含任何恶意代码或强制下载。我们不会要求用户下载任何播放器或插件，所有内容均通过浏览器直接播放，安全可靠。',
  },
];

export default function FAQSection() {
  const [openId, setOpenId] = useState<number | null>(1);

  const toggle = (id: number) => {
    setOpenId(openId === id ? null : id);
  };

  return (
    <section id="faq" className="py-14 md:py-20 px-4 md:px-8 bg-background-50">
      <div className="max-w-[900px] mx-auto">
        <div className="mb-8 md:mb-10 text-center">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900">
            常见问题
          </h2>
          <p className="text-sm text-foreground-500 mt-1">关于成全影视，你想知道的都在这里</p>
        </div>

        <div className="space-y-3">
          {faqs.map((faq) => (
            <div
              key={faq.id}
              className="bg-background-100 rounded-xl overflow-hidden"
            >
              <button
                onClick={() => toggle(faq.id)}
                className="w-full flex items-center justify-between gap-4 p-4 md:p-5 text-left cursor-pointer transition-colors duration-200 hover:bg-background-200"
              >
                <h3 className="text-sm md:text-base font-heading font-semibold text-foreground-900 flex-1">
                  {faq.q}
                </h3>
                <div className="flex-shrink-0 w-8 h-8 rounded-lg bg-background-50 flex items-center justify-center">
                  <i className={`text-foreground-500 transition-transform duration-300 text-lg ${
                    openId === faq.id ? 'ri-subtract-line' : 'ri-add-line'
                  }`}></i>
                </div>
              </button>

              {openId === faq.id && (
                <div className="px-4 md:px-5 pb-4 md:pb-5">
                  <div className="border-t border-background-200/70 pt-4">
                    <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
                  </div>
                </div>
              )}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}